import { render } from "./Alert.vue?vue&type=template&id=b98f4f30"
import script from "./Alert.vue?vue&type=script&lang=js"
export * from "./Alert.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rigun/MyData/project/masehi-kudus/sch-fe-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__